import { h } from 'preact';
export const Maximize2 = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polyline", { points: "15 3 21 3 21 9" }),
        h("polyline", { points: "9 21 3 21 3 15" }),
        h("line", { x1: "21", y1: "3", x2: "14", y2: "10" }),
        h("line", { x1: "3", y1: "21", x2: "10", y2: "14" })));
};
//# sourceMappingURL=maximize-2.js.map